import React from 'react'

type Props = {
  jobID: string
  resultImageUrl: string
  onBack: () => void
  onStartOver: () => void
  onSaveAsImage: () => void
  onImport: () => void
  copyPanel?: React.ReactNode
}

export function ResultStep({
  resultImageUrl,
  onBack,
  onStartOver,
  onSaveAsImage,
  onImport,
  copyPanel,
}: Props) {
  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      <div className="flex-1 overflow-hidden p-8">
        <div
          className={
            copyPanel
              ? 'grid grid-cols-[3fr_2fr] gap-8 w-full max-w-7xl mx-auto h-full min-h-0'
              : 'flex flex-col gap-6 max-w-3xl mx-auto h-full min-h-0'
          }
        >
          {/* Left: image + download */}
          <div className="flex flex-col gap-4 min-h-0">
            <div className="flex-1 min-h-0 rounded-2xl overflow-hidden border border-gray-200 shadow-lg">
              <img
                src={resultImageUrl}
                alt="AI generated ad"
                className="w-full h-full object-contain"
              />
            </div>

            <div className="flex-shrink-0">
              <a
                href={resultImageUrl}
                download
                className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
              >
                <i className="fa fa-download" />
                Download
              </a>
            </div>
          </div>

          {/* Right: copy panel */}
          {copyPanel && <div className="min-w-0 overflow-y-auto">{copyPanel}</div>}
        </div>
      </div>

      {/* Footer */}
      <div className="flex-shrink-0 border-t border-gray-200 bg-white px-6 py-4 flex items-center justify-between shadow-[0_-2px_8px_rgba(0,0,0,0.06)]">
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onBack}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <i className="fa fa-arrow-left" />
            Back
          </button>
          <button
            type="button"
            onClick={onStartOver}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <i className="fa fa-rotate-left" />
            Start Over
          </button>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onSaveAsImage}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-purple-600 text-purple-600 font-semibold text-sm hover:bg-purple-50 transition-colors"
          >
            <i className="fa fa-image" />
            Save as Ad Image
          </button>
          <button
            type="button"
            onClick={onImport}
            className="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-purple-600 text-white font-semibold text-sm hover:bg-purple-700 transition-colors shadow-md"
          >
            <i className="fa fa-file-import" />
            Import
          </button>
        </div>
      </div>
    </div>
  )
}
